import DepositPaymentOrderSettings from "@/models/Products/ProductSettings/DefaultSettings/PaymentOrders/DepositPaymentOrderSettings";
import CurrencyUtils from "@/lib/currencyUtils";

export default class UpdateDepositPaymentOrderSettingsRequest extends DepositPaymentOrderSettings {
    updatedAt: Date;

    public constructor(settings: DepositPaymentOrderSettings, updatedAt: Date, defaultWalletCurrency: string) {
        super();
        this.updatedAt = updatedAt;
        if (settings) {
            this.overridable = settings.overridable;
            this.oneApprovalThresholdEnabled = settings.oneApprovalThresholdEnabled;
            this.twoApprovalThresholdEnabled = settings.twoApprovalThresholdEnabled;
            this.threeApprovalThresholdEnabled = settings.threeApprovalThresholdEnabled;
            this.oneApprovalThreshold.currency = defaultWalletCurrency;
            this.oneApprovalThreshold.amount = CurrencyUtils.convertDecimalStringToAmountString(settings.oneApprovalThreshold.amount);
            this.twoApprovalThreshold.currency = defaultWalletCurrency;
            this.twoApprovalThreshold.amount = CurrencyUtils.convertDecimalStringToAmountString(settings.twoApprovalThreshold.amount);
            this.threeApprovalThreshold.currency = defaultWalletCurrency;
            this.threeApprovalThreshold.amount = CurrencyUtils.convertDecimalStringToAmountString(settings.threeApprovalThreshold.amount);
        }
    }
}